module.exports = __webpack_public_path__ + "static/img/iosDownload.df549a72.png";